<template>
  <div>
    <a href="https://www.afisha.ru/" @click="sendGaLink('афиша')" class="afisha_link" target="blank"><img
        src="../../assets/images/common/afisha.png" alt=""></a>
    <a @click="sendGaLink('гевискон')"
       href="https://www.eapteka.ru/goods/id309251/?utm_source=Afisha_SP&utm_medium=Buy_Button&utm_campaign=foodbol"
       class="gaviscon_link" target="_blank"><img src="../../assets/images/common/gaviscon.png" alt=""></a>
    <span class="spec_link">спецпроект</span>
    <share-block></share-block>
    <slot></slot>
    <div class="bot-block">
      <div class="line-1">
        Имеются противопоказания. Перед применением необходимо проконсультироваться со специалистом

      </div>
      <div class="line-2">Фармакотерапевтическая группа: средство лечения рефлюкс-эзофагита. Рег. уд.: ЛС-002445;
        ЛС-002444; ЛС-002447; ЛП-001587; ЛП-001624
      </div>
    </div>
  </div>
</template>

<script>
    import ShareBlock from "../ShareBlock";

    export default {
        name: "fixedBlocks",
        components: {
            ShareBlock
        },
        methods: {
            sendGaLink(title) {
                this.$ga.event('Ссылка', 'Переход по ссылке "' + title + '"', 1);
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/scss/mixins.scss";

  .afisha_link {
    position: fixed;
    top: 40px;
    left: 45px;
    display: block;
    z-index: 299;
  }

  .spec_link {
    position: fixed;
    color: #ffffff;
    font-size: 12px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    display: block;
    left: 41px;
    bottom: 8.5vh;
    letter-spacing: 0;
    z-index: 299;
    text-decoration: none;
    text-transform: uppercase;
    user-select: none;
  }

  .gaviscon_link {
    position: fixed;
    top: 25px;
    right: 44px;
    display: block;
    z-index: 299;
  }

  .bot-block {
    background: #c12482;
    position: fixed;
    z-index: 301;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7vh;
    min-height: 53px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    .line-1 {
      color: #ffffff;
      font-size: 1.74vw;
      font-weight: 100;
      text-transform: uppercase;
      margin-top: 5px;
      padding-right: 20px;
      transform: scaleY(1.5313);
      overflow: hidden;
    }
    .line-2 {
      color: #ffffff;
      font-size: 12px;
      font-weight: 300;
      line-height: 15px;
      margin-top: 5px;
      text-align: center;
      overflow: hidden;
    }

  }

  .test-page {
    .left-top, .right-top, .left-bot, .right-bot, .bot-block-mobile, .afisha_link, .gaviscon_link, .spec_link {
      position: absolute !important;
    }
  }
</style>